<template>
</template>
<script>
    import PreviewElement from "./PreviewElement";
    import HorizontalLineElement from "../../components/pagesbuilder/elements/HorizontalLineElement";

    export default {
        name: "PreviewHorizontalLineElement",
        mixins: [PreviewElement,HorizontalLineElement]
    }
</script>
